"use strict";

exports.__esModule = true;
exports.filterLayoutElementsByUserRoles = exports.filterLayoutElementsByUser = exports.LayoutVisibility = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Profile = require("../../Profile");
var _Core = require("../../Core");
var _useAdministrativeTenant = _interopRequireDefault(require("../../AdministrativeTenant/Hooks/useAdministrativeTenant"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var filterLayoutElementsByUserRoles = exports.filterLayoutElementsByUserRoles = function filterLayoutElementsByUserRoles(userRoles, items) {
  return items == null ? void 0 : items.filter(function (item) {
    var _item$element, _item$element2, _item$element3;
    if ((item == null || (_item$element = item.element) == null || (_item$element = _item$element.props) == null ? void 0 : _item$element.rolesVisibility) == null || (item == null || (_item$element2 = item.element) == null || (_item$element2 = _item$element2.props) == null || (_item$element2 = _item$element2.rolesVisibility) == null ? void 0 : _item$element2.length) === 0) {
      return true;
    }
    return item == null || (_item$element3 = item.element) == null || (_item$element3 = _item$element3.props) == null ? void 0 : _item$element3.rolesVisibility.some(function (roleVisibility) {
      return userRoles.some(function (userRole) {
        return (userRole == null ? void 0 : userRole.name) === roleVisibility;
      });
    });
  });
};
var filterLayoutElementsByUser = exports.filterLayoutElementsByUser = function filterLayoutElementsByUser(user, items) {
  return items == null ? void 0 : items.filter(function (item) {
    var _item$element4, _item$element5, _item$element6;
    if ((item == null || (_item$element4 = item.element) == null || (_item$element4 = _item$element4.props) == null ? void 0 : _item$element4.usersVisibility) == null || (item == null || (_item$element5 = item.element) == null || (_item$element5 = _item$element5.props) == null || (_item$element5 = _item$element5.usersVisibility) == null ? void 0 : _item$element5.length) === 0) {
      return true;
    }
    return item == null || (_item$element6 = item.element) == null || (_item$element6 = _item$element6.props) == null ? void 0 : _item$element6.usersVisibility.some(function (usersVisibility) {
      return usersVisibility.includes(user == null ? void 0 : user.id);
    });
  });
};
var userContainsRolesToDisplayLayout = function userContainsRolesToDisplayLayout(userRoles, layoutRolesVisibilities) {
  return layoutRolesVisibilities == null || (layoutRolesVisibilities == null ? void 0 : layoutRolesVisibilities.length) === 0 ? true : userRoles.some(function (userRole) {
    return layoutRolesVisibilities.includes(userRole == null ? void 0 : userRole.name);
  });
};
var userIsInUserListToDisplayLayout = function userIsInUserListToDisplayLayout(user, layoutUsersVisibilities) {
  return layoutUsersVisibilities == null || (layoutUsersVisibilities == null ? void 0 : layoutUsersVisibilities.length) === 0 ? true : layoutUsersVisibilities.some(function (layoutUsers) {
    return layoutUsers === user.id;
  });
};
var LayoutVisibility = exports.LayoutVisibility = function LayoutVisibility(_ref) {
  var layoutRolesVisibilities = _ref.layoutRolesVisibilities,
    layoutUsersVisibilities = _ref.layoutUsersVisibilities,
    children = _ref.children;
  var _useContext = (0, _react.useContext)(_Profile.ProfileContext),
    userRolesDetails = _useContext.userRolesDetails,
    user = _useContext.user;
  var isAdministrativeTenant = (0, _useAdministrativeTenant["default"])();
  var showLayout = true;
  if (!isAdministrativeTenant) {
    showLayout = userContainsRolesToDisplayLayout(userRolesDetails, layoutRolesVisibilities);
    if (showLayout) {
      showLayout = userIsInUserListToDisplayLayout(user, layoutUsersVisibilities);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, showLayout ? children : _Core.PermissionsError);
};